var $6b7f94ed17767636$exports = {};
$6b7f94ed17767636$exports = {
    "rangeUnderflow": (args)=>`Value must be ${args.minValue} or later.`,
    "rangeOverflow": (args)=>`Value must be ${args.maxValue} or earlier.`,
    "rangeReversed": `Start date must be before end date.`,
    "unavailableDate": `Selected date unavailable.`
};


export {$6b7f94ed17767636$exports as default};
//# sourceMappingURL=en-US.mjs.map
